export default __webpack_public_path__ + "60fc73d6c2f78675e99fee5119eb0090.png";